import {MENUS} from "../menu";

export const ROUTER_NAMES = {
    EVENTOEDICAOTICAO: 'Edicões dos Eventos',
    EDICOESABERTAS: 'Edicões Abertas'
}

export default [
    {
        name: ROUTER_NAMES.EVENTOEDICAOTICAO,
        path: '/edicao-evento',
        meta: {
            menu: MENUS.SISTEMA,
            searchAlias: 'EventoEdicao',
            searchDescription: 'Veja todas as Edicões de Eventos cadastradas',
            searchTerms: ['evento','edições'],
            hasRole: 'role/eventoEdicao'
        },
        component: () => import('@/views/EventoEdicao')
    },
    {
        name: ROUTER_NAMES.EDICOESABERTAS,
        path: '/edicoes-abertas',
        meta: {
            menu: MENUS.SISTEMA,
            searchAlias: 'Edicões Abertas',
            searchDescription: 'Veja todas as Edicões de Eventos Abertas',
            searchTerms: ['evento','edições'],
            hasRole: 'role/edicoesAbertas'
        },
        component: () => import('@/views/EventoEdicao/EdicoesAbertas')
    },
]